// El backend ya manda la fecha y la hora resueltas en la zona horaria de la
// app (campos fechaLocal / horaLocal). Acá solo se les da formato, así que no
// hace falta volver a hacer cuentas de husos.

const MESES_CORTOS = [
  'ene', 'feb', 'mar', 'abr', 'may', 'jun',
  'jul', 'ago', 'sep', 'oct', 'nov', 'dic',
];

const MESES_LARGOS = [
  'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
  'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre',
];

const DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

interface Partes {
  anio: number;
  mes: number;
  dia: number;
  diaSemana: number;
}

/// Descompone un 'YYYY-MM-DD'. Se ancla al mediodía UTC para que el día de la
/// semana no se corra por el huso del navegador.
function partes(fechaLocal: string): Partes {
  const [anio, mes, dia] = fechaLocal.split('-').map(Number) as [number, number, number];
  const anclaje = new Date(Date.UTC(anio, mes - 1, dia, 12));
  return { anio, mes, dia, diaSemana: anclaje.getUTCDay() };
}

export function diaYMes(fechaLocal: string): { dia: string; mes: string } {
  const p = partes(fechaLocal);
  return { dia: String(p.dia), mes: MESES_CORTOS[p.mes - 1] ?? '' };
}

/// "miércoles 24 de septiembre"
export function fechaLarga(fechaLocal: string): string {
  const p = partes(fechaLocal);
  return `${DIAS[p.diaSemana]} ${p.dia} de ${MESES_LARGOS[p.mes - 1]}`;
}

/// "24/9"
export function fechaCorta(fechaLocal: string): string {
  const p = partes(fechaLocal);
  return `${p.dia}/${p.mes}`;
}

/// "Cierra 24/9 18:00". La hora se omite cuando el cierre es a fin del día,
/// que es el valor por defecto y no aporta nada leerlo.
export function textoCierre(fechaLocal: string, horaLocal: string | null): string {
  const base = `Cierra ${fechaCorta(fechaLocal)}`;
  if (!horaLocal || horaLocal === '23:59') return base;
  return `${base} ${horaLocal}`;
}

/// Línea de contexto del evento: fecha, hora y lugar.
export function lineaDeEvento(
  fechaLocal: string,
  horaLocal: string,
  lugar: string | null,
): string {
  return [`${fechaLarga(fechaLocal)}`, `${horaLocal} hs`, lugar?.trim() || 'Lugar a definir'].join(
    ' · ',
  );
}

export function lineaCorta(fechaLocal: string, horaLocal: string): string {
  const { dia, mes } = diaYMes(fechaLocal);
  return `${dia} ${mes} · ${horaLocal} hs`;
}

export function textoConfirmados(cantidad: number): string {
  if (cantidad === 0) return 'Sin confirmaciones todavía';
  return cantidad === 1 ? '1 confirmado' : `${cantidad} confirmados`;
}
